import { getSelectedOfferingIds } from '../../ShoppingBasket/shoppingBasketHelpersCoCo.js';
import { isCustomerOwnedCpe, isFixedMobileBroadband } from './characteristicsFlagsUtilsCoCo.js';
import type { ProductOfferingCartItems } from '../../../common/types/shoppingBasketCoCo.js';
import type { ProductConfigSchema } from '../productConfig/useProductConfigSchemaCoCo.js';

export const hasSelectedCustomerOwnedCpe = (basketItem: ProductOfferingCartItems): boolean =>
  (basketItem.bundleAddonGroup ?? []).some(group => {
    const selectedOfferingIds = new Set(getSelectedOfferingIds(group, basketItem));
    return (group.productOffering ?? []).some(
      offering => selectedOfferingIds.has(offering.id) && isCustomerOwnedCpe(offering)
    );
  });

/** The API accepts an existing SIM for Fixed Mobile Broadband only together with a customer-owned device. */
export const isSimSectionHidden = (schema: ProductConfigSchema, basketItem: ProductOfferingCartItems): boolean =>
  schema.needsActiveSim && isFixedMobileBroadband(basketItem) && !hasSelectedCustomerOwnedCpe(basketItem);
